import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { fetchDefault } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { useHistory } from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import HowPayDialog from './seat/HowPayDialog';


const useStyles = makeStyles(theme => ({
    textField: {
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(1),
        width: 200,
    },
    menu: {
        width: 180,
    },
}));


const answerList = [
    {
        value: 0,
        label: '아니오',
    },
    {
        value: 1,
        label: '네',
    },
];


export default function SmsAgreement() {
    const classes = useStyles();
    let history = useHistory();

    const [min, setMin] = React.useState(1);
    const [day, setDay] = React.useState(1);

    const handleChangeMin = event => {
        setMin(event.target.value);
    };

    const handleChangeDay = event => {
        setDay(event.target.value);
    };

    const handleConfirm = event => {
        fetchDefault('/User/SetSMSAgreement?min=' + min +'&day=' + day,
            (data) => {
                alert('설정이 완료되었습니다.');
                history.push('/');
            }
        );

    };

    useEffect(() => {

        fetchDefault('/User/GetSMSAgreement',
            (data) => {
                setMin(data.min);
                setDay(data.day);
            }
        );

        return () => {
        }
    }, []);

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>종료시간 문자알림 설정</h2>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1">
                                자리 이용 종료 5분 전 / 지정석, 월정액, 사물함 이용 종료 1일 전 문자 알림을 수신하실지 설정할 수 있습니다.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 자리 이용 종료 5분 전 문자 알림을 수신합니다.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Select"
                        className={classes.textField}
                        value={min}
                        onChange={handleChangeMin}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                    >
                        {answerList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 지정석, 월정액, 사물함 이용 종료 1일 전 문자 알림을 수신합니다.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="Select"
                        className={classes.textField}
                        value={day}
                        onChange={handleChangeDay}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                    >
                        {answerList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12}>
                    <Button variant="outlined" color="primary" onClick={() => handleConfirm()} className={classes.button}>
                        설정 완료
                    </Button>
                </Grid>

            </Grid>

        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/SmsAgreement.js